module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoading) ? _c('mu-card', {
    attrs: {
      "id": "similarPosts"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "readNext",
      "title": _vm.$t('message.lifeCategoryListsHeaderText')
    }
  }), _vm._v(" "), _c('mu-card-text', _vm._l((_vm.posts), function(post, index) {
    return _c('div', {
      key: ("sidepost-" + index),
      staticClass: "sidePost"
    }, [_c('life-post-info', {
      attrs: {
        "slug": post.post_slug,
        "image": post.post_image,
        "title": post.post_title,
        "time": post.post_date,
        "favourites": post.post_favourites
      }
    })], 1)
  }), 0)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a035d63","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LifeStyle/LifeSimilarPosts/LifeSimilarPosts.vue
// module id = 3210
// module chunks = 1